import { useCallback } from 'react';
import axios, { useApiRequest } from './axios';
import { DemoState } from '../types/tenants';

const DEMO_URL = '/demo/';
const DEMO_OFFERED_URL = '/demo/offered/';
// Clearing truncates the whole workspace in one go - quick, but past the
// default 8 s on a busy server is not unthinkable.
const CLEAR_TIMEOUT = 60000;

export const useDemo = () => {
  const { loading, error, executeRequest } = useApiRequest();

  const query = useCallback(async (): Promise<DemoState | null> => {
    const { data, success } = await executeRequest(() => axios.get(DEMO_URL));
    return success ? data : null;
  }, [executeRequest]);

  /** Queues the load; the workspace reports status "L" until it is done. */
  const start = useCallback(
    async () => executeRequest(() => axios.post(DEMO_URL)),
    [executeRequest]
  );

  const clear = useCallback(
    async () => executeRequest(() => axios.delete(DEMO_URL, { timeout: CLEAR_TIMEOUT })),
    [executeRequest]
  );

  const markOffered = useCallback(async () => {
    try {
      await axios.post(DEMO_OFFERED_URL);
    } catch {
      // Not recorded - the prompt may show once more on a later visit.
    }
  }, []);

  return { loading, error, query, start, clear, markOffered };
};
